'use client';

import { CalendarProvider } from '@loci/types';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/atoms/primitives/sheet';
import { Button } from '@/components/atoms/Button';

const PROVIDERS: { key: CalendarProvider; label: string }[] = [
  { key: CalendarProvider.GOOGLE, label: 'Google Calendar' },
  { key: CalendarProvider.OUTLOOK, label: 'Outlook' },
  { key: CalendarProvider.APPLE, label: 'Apple Calendar' },
  { key: CalendarProvider.ICS_DOWNLOAD, label: 'Download ICS File' },
];

export interface CalendarProviderPickerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (provider: CalendarProvider) => void;
  /**
   * WEB-426: forwarded to the underlying Radix `Dialog.Content`
   * `onCloseAutoFocus`. This is a controlled sheet with no `SheetTrigger`, so
   * Radix's default close behaviour restores focus to `<body>` instead of the
   * control that opened it. The connected `AtAGlanceCard` passes a handler that
   * `event.preventDefault()`s Radix's restore and refocuses the "Add to
   * calendar" trigger, satisfying the WCAG focus-restoration contract.
   */
  onCloseAutoFocus?: (event: Event) => void;
}

export function CalendarProviderPicker({
  open,
  onOpenChange,
  onSelect,
  onCloseAutoFocus,
}: CalendarProviderPickerProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        title={null}
        className="rounded-t-2xl px-6 pb-8"
        onCloseAutoFocus={onCloseAutoFocus}
      >
        <SheetHeader className="items-center">
          <SheetTitle className="text-lg">Add to Calendar</SheetTitle>
        </SheetHeader>
        <div className="mt-4 flex flex-col gap-2">
          {PROVIDERS.map((p) => (
            <Button key={p.key} variant="ghost" onClick={() => onSelect(p.key)}>
              {p.label}
            </Button>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
